import FieldRow from 'components/FormElements/FieldRow';
import { Address, dateToLabel, getFormattedAddress } from 'further-ui/utils';

type UtmSource = {
  firmId: {
    _id: string;
    firmName: string;
  };
  value: string;
  firstLoginDate: string | Date | null;
};

type Props = {
  adviserData: {
    firstName: string;
    middleName: string;
    lastName: string;
    fcaNumber: string;
    phoneNumber: string;
    email: string;
    address: Array<Address>;
    lastLoginDate?: string;
    utmSources?: Array<UtmSource>;
  };
  firmId?: string;
};

const AdviserBasicDetails = ({ adviserData, firmId }: Props) => {
  const getUtmSourceLabel = (source?: UtmSource) =>
    source
      ? `${source.value} (${dateToLabel(source.firstLoginDate, '-')})`
      : '';

  const firmUtmSource =
    firmId &&
    getUtmSourceLabel(
      adviserData.utmSources?.find((source) => source.firmId._id === firmId),
    );

  return (
    <>
      <FieldRow title="First name" centerTitle>
        {adviserData.firstName}
      </FieldRow>
      <FieldRow title="Middle name" centerTitle>
        {adviserData.middleName}
      </FieldRow>
      <FieldRow title="Last name" centerTitle>
        {adviserData.lastName}
      </FieldRow>
      <FieldRow title="Personal FCA number" centerTitle>
        {adviserData.fcaNumber}
      </FieldRow>
      <FieldRow title="Phone number" centerTitle>
        {adviserData.phoneNumber}
      </FieldRow>
      <FieldRow title="Email address" centerTitle>
        {adviserData.email}
      </FieldRow>
      <FieldRow title="Correspondence address" centerTitle>
        {adviserData.address?.map((address, i: number) => (
          <div key={i}>{getFormattedAddress(address)}</div>
        ))}
      </FieldRow>
      <FieldRow title="Last login" centerTitle>
        {dateToLabel(adviserData.lastLoginDate, '-', true, true)}
      </FieldRow>
      {adviserData.utmSources && (firmUtmSource || !firmId) && (
        <FieldRow title="Source" centerTitle>
          {firmUtmSource ? (
            <div>{firmUtmSource}</div>
          ) : (
            adviserData.utmSources.map((source) => (
              <div key={source.firmId._id}>
                <span style={{ marginRight: '10px' }}>
                  {source.firmId.firmName}
                </span>
                <span>{getUtmSourceLabel(source)}</span>
              </div>
            ))
          )}
        </FieldRow>
      )}
    </>
  );
};

export default AdviserBasicDetails;
